import * as React from 'react';
import {connect} from 'react-redux';
import * as FleetModule from 'Modules/FleetModule';
import * as VehiclesModule from 'Modules/VehiclesModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import {withTranslation} from 'react-i18next';
import * as Dictionary from 'Models/Dictionary';
import {ActionDetailsIcon} from 'HelperFunctions/DetailsSidebarHelpers';
import {submit} from 'redux-form';
import LatestDataframesForm from 'components/Layout/Form/LatestDataframesForm';
import SearchHistoryLogAlerts from 'components/Layout/Form/SearchHistoryLogAlerts';
import {createSerachQuery} from 'Connectors/_main';
import * as HistoryModule from 'Modules/HistoryModule';
import * as AlertModule from "Modules/AlertModule";
import {combineClasses} from "components/Layout/Search/Search.Component";
import {DateRangeValue} from "Models/Dictionary";

type P = {
  history?: any;
  edit: boolean;
  match?: any;
};
type ConnectedP = {
  activeEl: VehiclesModule.Types.CarDto;
};
type DispatchedP = {
  showPopup: (popupData: ViewManagementModule.Types.Popup) => void;
  t?: (key: string) => string;
  fleetFormSubmit: () => void;
  deleteFleet: (fleetId: number) => void;
  setActiveFleet: (fleet: FleetModule.Types.CarFleetDto) => void;
  getLatestDataframes: (carId: number, formData: { dateRange: DateRangeValue}) => Promise<void>;
  getLatestAlerts: (params: URLSearchParams) => void;
  clearActiveVehicle: () => void;
  clearActiveDataframes: () => void;
};
type S = {};

class ManageCarPreview extends React.Component<P & ConnectedP & DispatchedP, S> {
  private dateRange: any;

  constructor(props: P & ConnectedP & DispatchedP) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.dateRange = Dictionary.generateDateRangesList()[0];
  }

  public async componentWillUnmount() {
    await this.props.clearActiveVehicle();
    await this.props.clearActiveDataframes();
  }

  public render() {
    const { t } = this.props;
    const { latestDataframe } = this.props.activeEl ?? {}
    const page = this.props.match.url.split('/')[3];

    const shouldLinkBeDisabled = !latestDataframe
      || typeof latestDataframe?.latitude !== 'number'
      || typeof latestDataframe?.longitude !== 'number'

    return (
      <div className="details-right__dashboard">
        <div
          className={`details-right__dashboard-item ${page === 'history' ? 'details-right__dashboard-item--disabled' : ''}`}
          onClick={() => this.redirect('history')}>
          <div className={'details-right__dashboard-icon'}>
            <img src={`/images/icons/calendar_blue.svg`} alt=""
                 className="details-right__dashboard-icon--mini"/>
          </div>
          <span>{t('carHistory')}</span>
        </div>
        <div
          className={`details-right__dashboard-item ${page === 'alert' ? 'details-right__dashboard-item--disabled' : ''}`}
          onClick={() => this.redirect('alert')}>
          <div className={'details-right__dashboard-icon'}>
            <img src={`/images/icons/alert.svg`} alt="" className="details-right__dashboard-icon--mini"/>
          </div>
          <span>{t('alertHistory')}</span>
        </div>
        <div
          className={`details-right__dashboard-item ${page === 'diagnostic' ? 'details-right__dashboard-item--disabled' : ''}`}
          onClick={() => this.redirect('diagnostic')}>
          <div className={'details-right__dashboard-icon'}>
            <img src={`/images/icons/car.svg`} alt="" className="details-right__dashboard-icon--mini"/>
          </div>
          <span>{t('carDiagnostic')}</span>
        </div>
        <div className={combineClasses('details-right__dashboard-item', shouldLinkBeDisabled && 'details-right__dashboard-item--disabled')}>
          <a
            className="details-right__dashboard-item--link"
            href={`https://www.google.com/maps/search/?api=1&query=${latestDataframe?.latitude},${latestDataframe?.longitude}`}
            target="_blank"
            // @ts-ignore
            disabled={shouldLinkBeDisabled}
            aria-disabled={shouldLinkBeDisabled}
          >
            <span className={'details-right__dashboard-icon'}><img src={`/images/icons/google-maps.svg`} alt="" className="details-right__dashboard-icon--mini"/></span>
            <span>{t('SHOW_IN_GOOGLE_MAPS')}</span>
          </a>
        </div>
        <ActionDetailsIcon
          active
          iconSrc={`/images/icons/addSign.svg`}
          title={t('forms:goBack')}
          rotate
          onClick={() => {
            this.props.history.goBack()
          }}
        />
        {page === 'history' &&
          <LatestDataframesForm onSubmit={this.handleSubmit} initialValues={{dateRange: this.dateRange.value}}/>}
        {page === 'alert' && <SearchHistoryLogAlerts onSubmit={this.handleSubmit}/>}
      </div>
    );
  }

  private redirect = (type: 'diagnostic' | 'history' | 'alert') => {
    const carId = this.props.match.url.split('/')[2];
    if (type !== this.props.match.url.split('/')[3]) {
      this.props.history.push(`${Dictionary.PageUrl.get(ViewManagementModule.EnumTypes.Page.CARS_MANAGEMENT)}/${carId}/${type}`);
    }
  };

  private async handleSubmit(formData: any) {
    const carId = this.props.match.url.split('/')[2];
    const page = this.props.match.url.split('/')[3];
    let params;

    switch (page) {
      case 'history':
        await this.props.getLatestDataframes(carId, formData);
        break;
      case 'alert':
        formData.carId = carId;
        params = createSerachQuery(formData);
        await this.props.getLatestAlerts(params);
        break;
      default:
        return 0;
    }
  }
}

function mapStateToProps(state: any): ConnectedP {
  return {
    activeEl: state.vehiclesStore.activeVehicleDetails
  };
}

function mapDispachToProps(dispatch: any): DispatchedP {
  return {
    showPopup: (popupData: ViewManagementModule.Types.Popup) => dispatch(ViewManagementModule.Actions.showPopup(
      popupData)),
    fleetFormSubmit: () => dispatch(submit('AddFleet')),
    deleteFleet: (fleetId: number) => dispatch(FleetModule.Actions.deleteFleet(fleetId)),
    setActiveFleet: (fleet: FleetModule.Types.CarFleetDto) => dispatch(FleetModule.Actions.setActiveFleet(fleet)),
    getLatestDataframes: (carId, formData) => dispatch(HistoryModule.Actions.getLatestDataframes(
      carId,
      {...formData})),
    getLatestAlerts: (params: URLSearchParams) => dispatch(AlertModule.Actions.getAlertHistoryLog(params)),
    clearActiveVehicle: () => dispatch(VehiclesModule.Actions.getSingleCarDetailsSuccess(null)),
    clearActiveDataframes: () => dispatch(HistoryModule.Actions.getLatestDataframesSuccess(null))
  };
}

export default withTranslation(['carDetails', 'forms'])(
  connect(
    mapStateToProps,
    mapDispachToProps
  )(ManageCarPreview) as React.ComponentType<any>
);



// WEBPACK FOOTER //
// ./src/components/Layout/DetailsSidebar/ManageCarPreview.tsx